import React from 'react';

// Material UI
import Grid from '@material-ui/core/Grid';

// Components
import DashboardLayout from '../_layout/DashboardLayout/dashboard.layout';
import { PageTitle } from '../../_core/_ui/typography.component';
import { SectionWrapper } from '../../_core/_ui/structure.components';
import { CreateAssessmentGraphQL } from '../../Assessment/CreateAssessment/create-assessment.graphql';
import { ROLES } from '../../../../_configuration';

export const CreateAssessmentPage = () => {
  return (
    <DashboardLayout hideSidebar requiredRoles={[ROLES.CONFIGURATION]}>
      <Grid item xs={12}>
        <PageTitle>Create New Assessment</PageTitle>
        <SectionWrapper>
          <CreateAssessmentGraphQL />
        </SectionWrapper>
      </Grid>
    </DashboardLayout>
  );
};
